export default [
    {
		path: '/tag-groups',
		name: 'Tag Groups',
		component: () => import('@/views/tagGroups/TagGroups.vue'),
        meta: {
			layout: 'Default',
			abilities: [['manage', 'tags']]
		}
	}
]
